import React from "react"
import './coupon.css'

const img_list = [
    'https://cdn.img.tyhjrbl.com/img/202604/02/13353zdiOv0feo.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1335hcvIc5ogyg.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1335bFR35Z5Cr7.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/13350qSDZSTats.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1335VOdpe971Gl.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/13368md3IlYByF.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/13362xsRLuojJv.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/133695fEkYDFf5.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1336gn8jrMJQZl.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1336tJkY1P4DHs.png'
]


export default function Coupon () {
    return (
        <>
            <div className='cou_box'>
                <div className='one'>
                    {img_list.slice(0, 2).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
                <div className='two'>
                    {img_list.slice(2, 4).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
                <div className='three'>
                    {img_list.slice(4, 6).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
                <div className='four'>
                    {img_list.slice(6 , 8).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
                <div className='five'>
                    {img_list.slice(8 , 10).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                    <div></div>
                </div>
            </div>
        </>
    )
}